import ufeApi from 'services/api/ufeApi';

const cancelServiceReservation = (token, { confirmationNumber, channel = 'rwd' }) => {
    const { sdnApiHost } = Sephora.configurationSettings;

    const url = `${sdnApiHost}/v2/happening/services/reservations/${confirmationNumber}?channel=${channel}`;

    return ufeApi.makeRequest(url, {
        method: 'DELETE',
        headers: {
            authorization: `Bearer ${token}`
        }
    });
};

export default cancelServiceReservation;
